import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import TextualContent from '../../TextualContent';
import { useDeviationViewContext } from '../../../Context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationTitle } from '../../_helpers';
import AutoSizedText from '../_partials/AutoSizedText';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import PremiumIconWithPopover from '../_partials/PremiumIconWithPopover';
import DeviationFlags from '../../../ActionBar/buttons/DeviationFlags';
import s from './Literature.scss';
const LiteratureFullView = ({ deviation: { dailyDeviation }, deviation, width, height })=>{
    var _deviation;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { isFullscreen, isTheater } = useDeviationViewContext();
    const style = (isTheater || isFullscreen) && !isMobile ? {
        width,
        height
    } : {
        width
    };
    const { isPremium, isPaidFolder } = normalizePremiumFolderData((_deviation = deviation) === null || _deviation === void 0 ? void 0 : _deviation.premiumFolderData);
    const deviationTitle = getDeviationTitle(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen']),
        style: style
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['letter-wrap']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['letter']
    }, /*#__PURE__*/ React.createElement(LiteratureCoverLetter, {
        alignment: "start",
        title: deviationTitle
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['content-wrap']
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['title-wrap'], isMobile && dailyDeviation && s['with-flag'])
    }, isMobile && dailyDeviation && /*#__PURE__*/ React.createElement("div", {
        className: s['flag']
    }, /*#__PURE__*/ React.createElement(DeviationFlags, {
        deviation: deviation
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['tag']
    }, isPremium && /*#__PURE__*/ React.createElement(PremiumIconWithPopover, {
        className: s['premium-icon'],
        isPaidFolder: isPaidFolder
    }), t('common.literature')), /*#__PURE__*/ React.createElement(AutoSizedText, {
        className: s['title'],
        tooBigClassName: s['better-fit'],
        maxHeight: 180
    }, deviationTitle)), isFullscreen && /*#__PURE__*/ React.createElement(TextualContent, {
        deviation: deviation,
        withArtist: false
    })));
};
LiteratureFullView.displayName = 'LiteratureFullView';
export default LiteratureFullView;
